// Constants for storage
const ONBOARDING_STORAGE_KEY = "onboardingData";
const COOKIE_EXPIRY_DAYS = 7;

// Helper function to set cookie with expiry
function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${JSON.stringify(value)};${expires};path=/`;
}

// Helper function to get cookie
function getCookie(name) {
  if (typeof document === "undefined") return null;

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const cookieValue = parts.pop().split(";").shift();
    try {
      return JSON.parse(cookieValue);
    } catch (e) {
      return cookieValue;
    }
  }
  return null;
}

// Helper function to delete cookie
function deleteCookie(name) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
}

// Function to save onboarding data
export function saveOnboardingData(data) {
  if (typeof window === "undefined") return;

  // Save to localStorage
  localStorage.setItem(ONBOARDING_STORAGE_KEY, JSON.stringify(data));

  // Save to cookie
  setCookie(ONBOARDING_STORAGE_KEY, data, COOKIE_EXPIRY_DAYS);
}

// Function to get onboarding data
export function getOnboardingData() {
  if (typeof window === "undefined") return null;

  // Try to get from localStorage first
  const localStorageData = localStorage.getItem(ONBOARDING_STORAGE_KEY);
  if (localStorageData) {
    try {
      return JSON.parse(localStorageData);
    } catch (e) {
      console.error("Error parsing localStorage data:", e);
    }
  }

  // Fallback to cookie
  return getCookie(ONBOARDING_STORAGE_KEY);
}

// Function to clear onboarding data
export function clearOnboardingData() {
  if (typeof window === "undefined") return;

  // Clear localStorage
  try {
    localStorage.removeItem(ONBOARDING_STORAGE_KEY);
  } catch (e) {
    console.error("Error removing from localStorage:", e);
  }

  // Clear cookie using the existing deleteCookie function
  try {
    deleteCookie(ONBOARDING_STORAGE_KEY);
  } catch (e) {
    console.error("Error removing cookie:", e);
  }
}

// Function to determine the appropriate step based on stored data
export function determineOnboardingStep(data) {
  if (!data) return "initial";

  const { email, slug, selectedTags, referralCode } = data;

  // If no email, start at initial
  if (!email) return "initial";

  // If no slug, go to slug step
  if (!slug) return "slug";

  // If no tags, go to tags step
  if (!selectedTags || selectedTags.length === 0) return "tags";

  // If no referral code, go to referral step
  if (!referralCode) return "referral";

  // If all data is present, go to referral step
  return "referral";
}
